// Module
var code = "<i-code-prompt [isGroupUserIdsBigModalEnabled]=\"isGroupUserIdsBigModalEnabled\" [text]=\"text\"></i-code-prompt> ";
// Exports
module.exports = code;